import { useState } from "react";
import { Favorite, FavoriteBorder, ShoppingCart } from "@mui/icons-material";
import { Button, Rating } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useAppContext } from "contexts";
import { ref, remove, set } from "firebase/database";
import { database } from "configs/firebaseConfigs";
import { db } from "hooks";
import { formatCurrency } from "@ashirbad/js-core";

const BasicCard = (props) => {
  //eslint-disable-next-line
  const [value, setValue] = useState(1);

  const navigate = useNavigate();

  const { user } = useAppContext();

  // console.log(props?.inCart);

  // console.log(user);

  const handleWishlist = () => {
    try {
      if (!user.uid) {
        Swal.fire({
          title: "Please login to add to wishlist",
          icon: "warning",
        });
        return;
      }

      const wishListData = {
        id: props.data.id,
        quantity: value,
        type: "product",
        createdAt: Date.now(),
      };
      set(
        ref(database, `wishlist/${user?.uid}/${props?.data?.id}`),
        wishListData
      )
        .then(async () => {
          await db.updateDb(`products/${props?.data?.id}`, {
            interestedIn: props?.data?.interestedIn + 1,
          });
          Swal.fire({
            title: "Added to wishlist",
            icon: "success",
          });
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Something Went Wrong. Try Again!",
            icon: "error",
          });
        });
    } catch (error) {
      Swal.fire({
        title: "Something Went Wrong. Try Again!",
        icon: "error",
      });
    }
  };

  const removeWishlist = async () => {
    try {
      await remove(ref(database, `wishlist/${user?.uid}/${props?.data?.id}`));
      await db.updateDb(`products/${props?.data?.id}`, {
        interestedIn: props?.data?.interestedIn - 1,
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  const handleCart = () => {
    try {
      if (!user.uid) {
        Swal.fire({
          title: "Please login to add to cart",
          icon: "warning",
        });
        return;
      }
      if (props?.inCart) {
        navigate("/cart");
        return;
      }
      const wishListData = {
        id: props.data.id,
        quantity: value,
        createdAt: Date.now(),
      };

      //check if item already in cart

      set(ref(database, `cart/${user?.uid}/${props?.data?.id}`), wishListData)
        .then(() => {
          Swal.fire({
            title: "Added to cart",
            icon: "success",
          }).then(() => {
            removeWishlist();
          });
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Something Went Wrong. Try Again!",
            icon: "error",
          });
        });
    } catch (error) {
      Swal.fire({
        title: "Something Went Wrong. Try Again!",
        icon: "error",
      });
    }
  };

  return (
    <>
      <div className="card-container">
        <div className="card-body">
          <Link to={`/product/${props?.data?.id}`}>
            <div className="h-100 w-100">
              <img
                src={props?.data?.images && props?.data?.images[0]?.url}
                alt="Card"
                className="card-img"
              />
            </div>
          </Link>
          <Button
            className="product-card-fav-btn"
            onClick={props?.inWishlist ? removeWishlist : handleWishlist}
          >
            {props?.inWishlist ? <Favorite /> : <FavoriteBorder />}
          </Button>
          {props?.data?.discount > 0 && (
            <span className="card-on-sale">Sale</span>
          )}
        </div>

        <div className="card-footer gap-1 flex-column align-items-center">
          <div className="card-footer-name">
            <h1 className="card-footer-name-text">
              <Link to={`/product/${props?.data?.id}`}>
                {props?.data?.name}
              </Link>
            </h1>
          </div>
          <div className="card-price flex-column gap-1 ">
            <span className="flex-row align-items-center gap-2 card-price-inner justify-content-center ">
              <span className="card-price-text">SAR {props?.data?.price}</span>
              {props?.data?.discount > 0 && (
                <span className="card-price-discount-price">
                  {formatCurrency(
                    (props?.data?.price * (100 + props?.data?.discount)) / 100,
                    "SAR"
                  )}
                </span>
              )}
              {props?.data?.discount && props?.data?.discount > 0 && (
                <span className="percent-discount">
                  (-{props?.data?.discount}%)
                </span>
              )}
            </span>
            <span className="flex-row align-items-center home-star-rating justify-content-center ">
              <Rating name="read-only" value={props?.data?.rating} readOnly />
            </span>
          </div>

          <div className="card-footer-end" onClick={handleCart}>
            <Button className="card-footer-add-cart flex-row align-items-center gap-1 ">
              {props?.inCart ? "View In Cart" : "Add To cart"} <ShoppingCart />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicCard;
